import * as React from 'react';
import cx from 'classnames';
import style from './Medium.css';
import shape from '_images/shape1.svg';
import {Carousel} from './Carousel';
import {ShapeGrey} from 'components/Shape';

class Article extends React.Component {
    render() {
        const props = this.props;

        return (
            <div ref={c => this.node = c} className={style.article}>
                <a className={style.articleLink} href={props.url} target="_blank">
                    <img className={style.articlePreview} src={props.image} alt=""/>
                </a>
                <span className={style.articleDate}>
                    {(new Date(props.date)).toLocaleDateString()}
                </span>
                <a className={style.articleLink} href={props.url} target="_blank">
                    <header className={style.articleHeader}>
                        {props.title}
                    </header>
                </a>

                <p className={style.articleDesc}>
                    {props.subtitle}
                </p>
                <a className={style.readMore} href={props.url} target="_blank">
                    Read more
                </a>
            </div>
        )
    }
}

export class Medium extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    }

    componentDidMount() {
        fetch('/api/get_medium_posts').then((response) => {
            return response.json();
        }).then((res) => {
            this.setState({items: res.data});
        });
    }

    render() {
        return (
            <section className={style.root}>
                <ShapeGrey className={style.shape1}/>
                <ShapeGrey className={style.shape2}/>

                <div className={cx(style.content, "container")}>
                    <h2 className={cx(style.itemHeader, 'wow fadeInUp')}>
                        BlockScience<br/>
                        on Medium
                    </h2>
                    <div className={cx(style.articles, 'wow fadeInUp')}>
                        <Carousel>
                            {this.state.items.map(item => <Article key={item.date} {...item}/>)}
                        </Carousel>
                    </div>
                </div>
            </section>
        )
    }
}